<template>
  <div class="video-container">
    <div
      v-if="!selectedVideo"
      class="video-list">
      <div
        v-for="(media, index) of this.sectionContent.Media"
        :key="index"
        class="video-item"
        @click="setSelected(media,index)"
      >
        <VideoThumbnail>
          <template #video-thumbnail>
            <img :src="media.Thumbnail[0]"/>
          </template>
          <template #video-title>{{ media.Name[0] }}</template>
        </VideoThumbnail>
      </div>
    </div>
    <div v-else class="video-player">
        <VideoPlayer
        :clickedVideo="selectedVideo"
        :clickedIndex="selectedIndex"
        :sectionContent="sectionContent"
        :chapter="chapter"
        :section="section"
        />
    </div>
  </div>
</template>

<script lang="js">
import VideoThumbnail from '@/components/media/VideoThumbnail'
import VideoPlayer from '@/components/media/VideoPlayer'
export default {
  name: 'MediaAudio',
  components: {
    VideoThumbnail,
    VideoPlayer
  },
  props: ['chapter', 'section', 'bookTitle', 'sectionContent'],
  data () {
    return {
      selectedVideo: null,
      selectedIndex: 0
    }
  },
  methods: {
    setSelected (media, index) {
      this.selectedVideo = media
      this.selectedIndex = index
    }
  }
}
</script>

<style lang="scss">
.video-container {
  padding-bottom: 20px;
  padding-top: 50px;
  width: 100%;
  .video-list {
    display: grid;
    justify-content: space-between;

    @media screen and (min-width: 1181px) {
      grid-template-columns: repeat(3, 30%);
    }

    @media only screen and (max-width: 1180px) and (min-width: 1160px) {
      grid-template-columns: repeat(3, 280px);
    }

    @media only screen and (max-width: 1159px) and (min-width: 861px) {
      grid-template-columns: repeat(3, 30%);
    }

    @media only screen and (max-width: 860px) and (min-width: 601px) {
      grid-template-columns: repeat(2, 45%);
      justify-content: space-evenly;
    }

    @media only screen and (max-width: 600px) {
      grid-template-columns: repeat(1, 80%);
      justify-content: center;
      max-height: 100%;
    }
  }
}
</style>
